<template>
  <div>
    <!-- Sin firma configurada -->
    <div v-if="!hasCertificate">
      <div v-if="ambit === ambits.profile">
        <h3>Firma Simple - Proveedor Signapis</h3>
        <p>
          Para comenzar a operar con <b>Firma Simple Electr&oacute;nica</b>, tu administrador
          debe habilitarte en el sistema. El enrolamiento se realiza directamente en
          la plataforma de <b>Signapis</b>.
        </p>
        <p>
          Comun&iacute;cate con tu administrador de sistema para que te habilite.
        </p>
      </div>
      <div v-else>
        <ActiveSignSignapiExterno
          :configurations="requestData"
          :user="user"
          @activate="activate"
        />
      </div>
    </div>

    <!-- Con firma configurada -->
    <div v-if="hasCertificate">
      <div class="row justify-content-center mb-3">
        <div class="col-lg-8 col-md-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Firma Electr&oacute;nica Simple - Signapis</h4>
              <div class="row">
                <div class="col-md-6">
                  <p><strong>Usuario:</strong> {{ user.nombre }}</p>
                  <p><strong>Correo:</strong> {{ user.correo }}</p>
                </div>
                <div class="col-md-6">
                  <p><strong>Proveedor:</strong> Signapis</p>
                  <p>
                    <strong>Estado:</strong>
                    <span :class="isActive ? 'text-success' : 'text-danger'">
                      {{ isActive ? 'Activa' : 'Inactiva' }}
                    </span>
                  </p>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <small class="text-muted">
                    El enrolamiento y gesti&oacute;n de credenciales se realiza directamente
                    en la plataforma de Signapis.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Configuración de estampa -->
      <div v-if="ambit === ambits.profile">
        <ConfigureStamp
          prefix="ssignapi"
          proveedor="S_SignAPI_E"
          tipoFirma="firmaSimple"
          :user="user"
        />
      </div>
      <div v-else>
        <PreviewStamp
          prefix="ssignapi"
          proveedor="S_SignAPI_E"
          tipoFirma="firmaSimple"
          :user="user"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActiveSignSignapiExterno from './ActiveSign';
import ConfigureStamp from '@/febos/global/usuario/components/sign/shared/ConfigureStamp';
import PreviewStamp from '@/febos/global/usuario/components/sign/shared/PreviewStamp';
import { ambits, certStatus } from './constants';

export default {
  name: 'SimpleSignSignapiExterno',
  components: {
    ActiveSignSignapiExterno,
    ConfigureStamp,
    PreviewStamp
  },
  data() {
    return {
      ambits
    };
  },
  computed: {
    hasCertificate() {
      return !!(this.requestData && this.requestData.id);
    },
    isActive() {
      if (this.requestData && this.requestData.parametros && this.requestData.parametros.activa) {
        return this.requestData.parametros.activa === certStatus.ACTIVE;
      }
      return false;
    }
  },
  methods: {
    activate() {
      this.$emit('activate', {});
    }
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    signConfiguration: {
      type: Object,
      required: false,
      default: () => ({})
    },
    requestData: {
      type: Object,
      required: false,
      default: () => ({})
    },
    ambit: {
      type: String,
      required: true,
      default: 'perfil'
    }
  }
};
</script>
